import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";
import OverviewCard from "./OverviewCard";

const COLORS = ["#10B981", "#F43F5E"];

const PaymentHealth = ({ paymentHealth }) => {
    const data = [
        { name: "Success", value: paymentHealth?.success || 0 },
        { name: "Failed", value: paymentHealth?.failed || 0 },
    ];

    const total = (paymentHealth?.success || 0) + (paymentHealth?.failed || 0);
    const successRate = total === 0 ? 0 : Math.round((paymentHealth.success / total) * 100);

    return (
        <OverviewCard title="Payment Health" subtitle="Successful vs failed payments" accent="emerald">
            <div className="flex items-center gap-4">
                <div className="h-36 w-36 shrink-0">
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <Pie
                                data={data}
                                cx="50%"
                                cy="50%"
                                innerRadius={40}
                                outerRadius={62}
                                paddingAngle={4}
                                dataKey="value"
                            >
                                {data.map((entry, index) => (
                                    <Cell key={index} fill={COLORS[index]} />
                                ))}
                            </Pie>
                            <Tooltip />
                        </PieChart>
                    </ResponsiveContainer>
                </div>

                <div className="flex-1 space-y-2">
                    <div className="flex items-center justify-between rounded-lg bg-emerald-50 px-3 py-2">
                        <span className="flex items-center gap-1.5 text-xs font-medium text-slate-600">
                            <span className="h-2 w-2 rounded-full bg-emerald-500" /> Successful
                        </span>
                        <span className="text-base font-bold tabular-nums text-emerald-700">
                            {paymentHealth?.success || 0}
                        </span>
                    </div>

                    <div className="flex items-center justify-between rounded-lg bg-rose-50 px-3 py-2">
                        <span className="flex items-center gap-1.5 text-xs font-medium text-slate-600">
                            <span className="h-2 w-2 rounded-full bg-rose-500" /> Failed
                        </span>
                        <span className="text-base font-bold tabular-nums text-rose-700">
                            {paymentHealth?.failed || 0}
                        </span>
                    </div>
                </div>
            </div>

            <div className="mt-4 flex items-center justify-between rounded-lg bg-gradient-to-r from-emerald-500 to-teal-500 px-4 py-2.5">
                <span className="text-sm font-medium text-white/90">Success Rate</span>
                <span className="text-lg font-bold tabular-nums text-white">{successRate}%</span>
            </div>
        </OverviewCard>
    );
};

export default PaymentHealth;